import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.defaultClient;

import MenuItemGql from '@/store/graphql/queries/MenuItem.gql';

export default {
  fetchItem: (path, cms) =>
    new Promise((resolve, reject) => {
      apolloClient
        .query({ query: MenuItemGql, variables: { path, cms: parseInt(cms) } })
        .then(({ data }) => resolve(data.CP_MenuItem))
        .catch(err => reject(err));
    })
};
